import '../css/site.scss';

import '@babel/polyfill';